import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../../Optics/Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { loadingCouplingDataComponent, loadingRankComponentDataComponent } from '../../../../Optics/LoadingData/LoadingDataComponents';
import { DeleteCouplingConstruction, UpdateCouplingDescriptionConstruction, UpdateCouplingNameConstruction, UpdateCouplingRankConstruction, UpdateWeldingCouplingConstruction } from '../../../WriteData/UpdateConstructCommunications';

const CouplingDescriptEditingModal = ({ open, onClose, onClose2, content, cantonCouplingRefresh, setIsComponentСhangeCoorCoupling}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [couplingData, setCouplingData] = useState([]);
  const [couplingId, setCouplingId] = useState("");
  const [rankComponentData, setRankComponentData] = useState([]);
  const [couplingRankId, setCouplingRankId] = useState("");
  const [weldingCount, setWeldingCount] = useState(content.weldingCount);
  const [statusChangeWelding, setStatusChangeWelding] = useState(false);


    const handleСhangeCoor= (event) => {
      handleCloseDialogs();
      setIsComponentСhangeCoorCoupling(true);
    }
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [couplingData, rankComponentData] = await Promise.all([
          loadingCouplingDataComponent(),
          loadingRankComponentDataComponent(),
        ]);
        setCouplingData(couplingData);
        setRankComponentData(rankComponentData);
      } catch (error) {
        // Обработка ошибок
        // console.error("Error in fetchData:", error);
      }
    };
  
    fetchData();
  }, []);

   const deleteCoupling = () => {
        DeleteCouplingConstruction(content.id, showSnackbar, cantonCouplingRefresh, handleCloseDialogs );
   };   

  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

   const handleWeldingChange = (event) => {
    const welding = event.target.value;
    setWeldingCount(welding);

    if (welding !== content.weldingCount) {
      setStatusChangeWelding(true);
    } else {
      setStatusChangeWelding(false);
    }
  };

 

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };
 
  const updateCoupling = () => {
    if (statusChange) {
      UpdateCouplingDescriptionConstruction(content.id, textComment, showSnackbar,content.authorId, cantonCouplingRefresh);
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };

  const handleChangeCouplingSelect = (event) => {
    const selectedCoupling = event.target.value;
    if (selectedCoupling === "") {
      setCouplingId("");
    } else {
      const selectedCoupling2 = couplingData.find(coupling => 
        `${coupling.id}` === selectedCoupling
      );
      if (selectedCoupling2) {
        setCouplingId(selectedCoupling2.id);
      }
    }
  };

  const updateCouplingName = () => { 
    if (couplingId === "") {
      showSnackbar('Нет нужды в записи, кабель без изменений!', 'snackbarOk');
    } else {
      UpdateCouplingNameConstruction(content.id, couplingId, showSnackbar,content.authorId, cantonCouplingRefresh );
    } 
  };

  const handleChangeCouplingRankSelect = (event) => {
    const selectedCouplingRank = event.target.value;
    if (selectedCouplingRank === "") {
      setCouplingRankId("");
    } else {
      const selectedCouplingRank2 = rankComponentData.find(couplingRank => 
        `${couplingRank.id}` === selectedCouplingRank
      );
      if (selectedCouplingRank2) {
        setCouplingRankId(selectedCouplingRank2.id);
      }
    }
  };

  const updateCouplingRank = () => {
  
    if (couplingRankId === "") {
      showSnackbar('Нет нужды в записи, ранг без изменений!', 'snackbarOk');
    } else {
      UpdateCouplingRankConstruction(content.id, couplingRankId, showSnackbar,content.authorId, cantonCouplingRefresh );
    } 
  };


   const updateWelding = () => {
     if (statusChangeWelding) {
         UpdateWeldingCouplingConstruction(content.id, weldingCount,content.authorId, showSnackbar, cantonCouplingRefresh );
      } else {
         showSnackbar('Нет нужды в записи, сварки без изменений!', 'snackbarOk');
      }
   };


    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      {content.rankComponentId === 1 || content.rankComponentId === 2 ? (
           <img src='./сoupling.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./coupling_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Редактирование муфты</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Округ: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #3d3d3d'}}>{content.canton} {content.region} {content.area}</span> </label>
     
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Муфта: </label>

        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeCouplingSelect(event);
          }} >
          <option value="">{content.couplingName}</option>
          {couplingData.map(coupling => (
            <option key={coupling.id} value={coupling.id}>{coupling.name}</option>
          ))}
        </select>
        <button onClick={updateCouplingName} class='buttonIsSaveDialog2'>Сохранить</button>
        <br/>
        <label style={{ color: '#292929', fontWeight: 'bold'}}>Сварки: </label>
       
            <input
              type='number'
              className='textInput2EditingModal'
              min={0}
              value={weldingCount} 
              onChange={handleWeldingChange} 
            /> <label className='textTitleDrawer' style={{marginLeft: '0px', fontSize: '16px'}}>шт. </label>
           
             <button onClick={updateWelding}  class='buttonIsSaveDialog2'>Сохранить</button>

        <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      
        <label style={{ color: '#292929', fontWeight: 'bold'}}>Мax ранг линка: </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeCouplingRankSelect(event);
          }} >
          <option value="">{content.rankComponentName}</option>
          {rankComponentData.map(rank => (
            <option key={rank.id} value={rank.id}>{rank.name}</option>
          ))}
        </select>
        <button onClick={updateCouplingRank} class='buttonIsSaveDialog2'>Сохранить</button>

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />

      <br/>
         <button onClick={updateCoupling} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>
      <hr className='horizontalLineDialog'/>

      <button  class='buttonIsEditDialog' onClick={handleСhangeCoor}> Редактировать на карте</button>
      <hr className='horizontalLineDialog'/>

      <button 
          className="buttonIsDeleteModal" 
          onClick={deleteCoupling} 
          style={{ fontSize: "14px", width: "60px", padding: "2px" ,textShadow: '2px 2px 4px #3d3d3d'}}
        >
          Удалить
        </button>

      <hr className='horizontalLineDialog'/>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
          Закрыть
        </Button>
      </DialogActions>

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

    
    </Dialog>
  );
}

export default CouplingDescriptEditingModal;